import { ChangeDetectorRef, Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { SurveyService } from '../service/survey.service';
import { UtilityService } from 'src/app/service/utility.service';
import { NotifierService } from 'angular-notifier';
import { ExcelService } from 'src/app/service/excel.service';
import  * as XLSX from 'xlsx';
// import * as FileSaver from 'file-saver';

@Component({
  selector: 'app-upload-rejections',
  templateUrl: './upload-rejections.component.html',
  styleUrls: ['./upload-rejections.component.scss']
})
export class UploadRejectionsComponent implements OnInit {
  // public tGroup:any = [];
  // public suvDetails: any = {};
  // public survey_id:string | null;
  // public fileObj:FileList;
  // public downloadFilename:string = "test.xlsx"
  public filesObj:any={
    "rejectionFile":FileList,
    "paymentFile":FileList
  };
  constructor(
    public surveyService:SurveyService,
    public route:Router,
    public activeRoute:ActivatedRoute,
    private cd: ChangeDetectorRef,
    public utility:UtilityService,
    public notifier: NotifierService,
    public excelService:ExcelService
  ) { 
    this.filesObj = {
      "rejectionFile":FileList,
      "paymentFile":FileList
    }
  }

  ngOnInit(): void {
    // this.getSurvayDetails();
    // this.survey_id = this.activeRoute.snapshot.paramMap.get("survey_id");
    // if (!this.surveyService.oprationsAccessRules.showOprations) {
    //   this.route.navigate([`/dashboard`]);
    // }
    if (!(this.surveyService.accessRoles && this.surveyService.accessRoles.settings && this.surveyService.accessRoles.settings.operations && this.surveyService.accessRoles.settings.operations.view)) {
      this.route.navigate([`/dashboard`]);
    }

  }


  // detailsRouterChange(){
  //   // let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id");
  //   this.route.navigate([`/survey/details/${this.survey_id}`]);
  // }
  // quotaRouterChange(){
  //   // let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id");
  //   this.route.navigate([`/survey/quota/${this.survey_id}`]);
  // }
  // tgQuotaRouterChange(){
  //   // let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id");
  //   this.route.navigate([`/survey/target-group/${this.survey_id}`]);
  // }
  // uploadRejectionRouterChange(){
  //   // let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id");
  //   this.route.navigate([`/survey/operations/${this.survey_id}`]);
  // }

  // getSurvayDetails(){
  //   if(!Object.keys(this.surveyService.surveyDetails).length)
  //   {
  //     let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id") || '';
  //     this.surveyService.getSurvayDetails(survey_id)
  //   .subscribe({
  //     next: (res: any) =>{
  //       if (res['status'] == 1) {
  //         this.suvDetails = res.result;
  //         this.surveyService.surveyDetails = res['result'];
  //         this.cd.detectChanges();
  //       }
  //     },error :(e) =>{
  //       console.log(e)
  //     }
  //   })
  //   }
  //   else
  //   {
  //     this.suvDetails = this.surveyService.surveyDetails;
  //   }
  // }

  // getLinkDetails(flag:number){
  //   if(flag === 0)
  //   {
  //     let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id") || '';
  //     this.surveyService.getDownloadLinkDetails(survey_id,1)
  //     .subscribe({
  //       next: (res: any) =>{
  //         if (res['status'] == 1) {
  //           this.surveyService.SurveyGetLink = res['links'];
  //           this.cd.detectChanges();
  //           this.utility.copyOnClick(res['links'][0]);
  
  //         }
  //       },error :(e) =>{
  //         console.log(e)
  //       }
  //     })
  //   }
  //   else
  //   {
  //     let survey_id = this.activeRoute.snapshot.paramMap.get("survey_id") || '';
  //     this.surveyService.getDownloadLinkDetails(survey_id,this.surveyService.defaultSurveyGetLink)
  //     .subscribe({
  //       next: (res: any) =>{
  //         if (res['status'] == 1) {
  //           this.surveyService.SurveyGetLink = res['links'];
  //           this.cd.detectChanges();
  //           // this.utility.copyOnClick(res['links'][0]);
  //           this.surveyService.downloadLink(res['links']);

  
  //         }
  //       },error :(e) =>{
  //         console.log(e)
  //       }
  //     })

  //   }
   
  // }


    uploadFile = (event:any,type:string) =>
    {
        const target = event.target;
        if (target) {
          const uploadedFileSize = target['files'] && target['files'][0] && target['files'][0].size || 0;
          if(uploadedFileSize <= (200 * 1024 * 1024)){
            this.acceptFileUpload(event,type);
          }
          else{
            this.notifier.notify('error',"Can't upload file larger than 200MB");
          }
        }
    }

    acceptFileUpload(event: Event, type:string){
      const target = event.target as HTMLInputElement;
      if (type == 'rejection') {
        this.filesObj['rejectionFile'] = target.files as FileList
      }else if (type == 'payment') {
        this.filesObj['paymentFile'] = target.files as FileList
      }
      console.log("this.filesObj --->",this.filesObj)
    }
    
    getFileName(name:string){
      return name.replace(/^.*(\\|\/|\:)/, '');
    }
    
    // submitRejection(){
    //   if (this.filesObj && this.filesObj['rejectionFile'] && this.filesObj['rejectionFile'].length) {
    //     let file = {fileObj:this.filesObj['rejectionFile'][0],file_type:'',fileName:this.getFileName(this.filesObj['rejectionFile'][0]['name'])}
    //     let jsonis = {}

    //     console.log("jsonis",jsonis)

    //     this.notifier.notify('success',"file uploaded successfully");
    //   }
    // }

    // submitPayment(){
    //   if (this.filesObj && this.filesObj['paymentFile'] && this.filesObj['paymentFile'].length) {
    //     let file = {fileObj:this.filesObj['paymentFile'][0],file_type:'',fileName:this.getFileName(this.filesObj['paymentFile'][0]['name'])}
    //     this.surveyService.onUploadPayment(file)
    //     this.notifier.notify('success',"file uploaded successfully");
    //   }
    // }

    submitRejection(body:any){
      if (this.filesObj && this.filesObj['rejectionFile'] && this.filesObj['rejectionFile'].length) {
        console.log("jsonis",body)
        this.surveyService.onUploadRejection(body)
        .subscribe({
          next: (res: any) =>{
            if (res['status'] == 1) {
              this.cd.detectChanges();
              // this.notifier.notify('success',"Data uploaded successfully");
              this.notifier.notify('success',res['message']);
            }else{
              this.notifier.notify('error',"Something went wrong.");
            }
          },error :(e) =>{
            console.log(e);
            this.notifier.notify('error',"Something went wrong.");
          }
        })
        
      }
    }

    submitPayment(body:any){
      if (body && Object.keys(body).length) {
        console.log("jsonis",body)
        this.surveyService.onUploadPayment(body)
        .subscribe({
          next: (res: any) =>{
            if (res['status'] == 1) {
              this.cd.detectChanges();
              // this.notifier.notify('success',"Data uploaded successfully");
              this.notifier.notify('success',res['message']);
            }else{
              this.notifier.notify('error',"Something went wrong.");
            }
          },error :(e) =>{
            console.log(e);
            this.notifier.notify('error',"Something went wrong.");
          }
        })
        // this.notifier.notify('success',"file uploaded successfully");
      }
    }

    importExcelFileToJson(files:File,type:string) {
      if (files) {
        let fileNameSplits = files.name.split(".");
        let fileType = fileNameSplits[fileNameSplits.length -1];
        if (fileType && (fileType == 'xlsx' || fileType == 'XLSX')) {
          let workBook: XLSX.WorkBook | null = null;
          let jsonData = null;
          const reader = new FileReader();
          const file = files;
          reader.onload = (event) => {
            const data = reader.result;
            workBook = XLSX.read(data, { type: 'binary' });
            jsonData = workBook.SheetNames.reduce((initial:any, name) => {
              if (workBook) {
                const sheet = workBook.Sheets[name];
                initial[name] = XLSX.utils.sheet_to_json(sheet);
              }
              return initial;
            }, {});
            // console.log("jsonData",Object.keys(jsonData))
            let body ={
              data :jsonData[Object.keys(jsonData)[0]]
            }
            if (type == 'rejection') {
              this.submitRejection(body)
            }else if (type == 'payment') {
              this.submitPayment(body)
            }
          }
          reader.readAsBinaryString(file);
        }else{
          this.notifier.notify('error',"Please upload xlsx file");
        }
      }else{
        this.notifier.notify('error',"Please select a file");
      }
    }
}
